import { render, staticRenderFns } from "./ChatView.vue?vue&type=template&id=478ecb33&scoped=true&"
import script from "./ChatView.vue?vue&type=script&lang=js&"
export * from "./ChatView.vue?vue&type=script&lang=js&"
import style0 from "./ChatView.vue?vue&type=style&index=0&id=478ecb33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478ecb33",
  null
  
)

export default component.exports